import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom'; // React Router의 useLocation 가져오기
import Sidebar from './Sidebar';
import Header from './Header';
import { MyPageUrl } from '../../url/poenUrl';

const LayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: calc(100% - 300px); // Sidebar의 너비를 뺀 나머지 공간을 차지
  @media (max-width: 968px) {
    width: 100%; // 모바일에서는 전체 너비 사용
  }
`;

const ContentWrapper = styled.div<{ $isMyPageActive: boolean }>`
  flex: 1;
  padding: 40px;
  background-color: ${(props) =>
    props.$isMyPageActive
      ? props.theme.colors.whiteColor // 활성화된 탭의 색상
      : props.theme.colors.bgColor}; // 기본 색상
  overflow-y: auto;

  @media (max-width: 968px) {
    padding: 20px;
    background-color: ${(props) =>
      props.$isMyPageActive
        ? props.theme.colors.whiteColor
        : props.theme.colors.whiteColor};
  }
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation(); // URL 정보를 가져오기 위한 useLocation 훅
  const [isMyPageActive, setIsMyPageActive] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 968) {
        setIsSidebarOpen(true); // 데스크탑에서는 열림
      } else {
        setIsSidebarOpen(false); // 모바일에서는 닫힘
      }
    };

    const checkUrl = () => {
      const url = location.pathname + location.search;
      // URL에서 activeTab=1 또는 activeTab=2가 포함되었는지 확인
      setIsMyPageActive(
        url.includes(MyPageUrl) &&
          (url.includes('activeTab=1') || url.includes('activeTab=2'))
      );
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // 초기 로드 시 화면 크기를 확인

    checkUrl(); // URL 변경 시 확인
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location]); // location이 변경될 때마다 실행

  return (
    <LayoutContainer>
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <MainContent>
        <Header toggleSidebar={toggleSidebar} />
        <ContentWrapper $isMyPageActive={isMyPageActive}>
          <PageContainer>{children}</PageContainer>
        </ContentWrapper>
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;
